/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_All_FilterInputs */



/**
* | output |
* | --- |
* | "All" |
*
* @param {Qc_All_FilterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_all_filter = /** @type {((inputs?: Qc_All_FilterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_All_FilterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Todos")
	return /** @type {LocalizedString} */ ("All")
});